import React, { useEffect } from "react";
import "./Inner_Calm_Meditation.css";
import Inner_Calm_Banner from "./inner_calm_banner/Inner_Calm_Banner";
import Benifits from "./benifits/Benifits";
import Essence_Of_Meditation from "./essence_of_meditation/Essence_Of_Meditation";
import Guidelines from "./guidelines/Guidelines";
import { useDispatch, useSelector } from "react-redux";
import { SingleMeditaion } from "../../features/admin/common/Slice";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utils/common";

const Inner_Calm_Meditation = () => {
  const dispatch = useDispatch();
  const { id } = useParams()
  const data2 = useSelector((state) => state.common.meditation);

  useEffect(() => {
    dispatch(SingleMeditaion(decodeId(id)));
  }, [dispatch])

  return (
    <section className="Inner_Calm_Meditation">
      <Inner_Calm_Banner image={data2?.image} name={data2?.name} time={data2?.time} desc={data2?.description} music={data2?.audio} video={data2?.video} />
      <Benifits
        benefits={data2?.Meditation_Benefits?.map(b => ({
          title: b.Meditation_Benefit_Languages?.[0]?.name || b.name,
          descn: b.Meditation_Benefit_Languages?.[0]?.subname || b.subname
        }))}
      />
      <Essence_Of_Meditation essences={data2?.Meditation_Essences?.map(e => ({
        title: e.Meditation_Essence_Languages?.[0]?.name || e.name
      }))}
      />
      <Guidelines guidelines={data2?.Meditation_Guidelines?.map(g => ({
        title: g.Meditation_Guideline_Languages?.[0]?.name || g.name,
        descn:
          g.Meditation_Guideline_Languages?.[0]?.description || g.description
      }))} />
    </section>
  );
};

export default Inner_Calm_Meditation;
